<template>
  <v-sheet
    style="overflow-x:hidden; overflow-y:auto ;z-index:1;position:relative;"
    class="highlight remaining-height"
    outlined
    :height="height"
    :width="width"
    rounded
    @dragenter.prevent="dragover = true"
    @dragover.prevent="dragover = true"
    @click="$refs.fileupload.click()"
    @drop="drop($event)"
  >
    <v-form ref="form">
      <input
        ref="fileupload"
        :accept="getMimeTypes"
        type="file"
        style="display:none"
        :multiple="multiple"
        @change="prepareFile($event)"
      >
    </v-form>
    <v-sheet
      v-if="dragover"
      color="rgba(0, 0, 0, 0.69)"
      style="position: absolute; top:0; bottom: 0; left: 0; right:0"
      @dragleave="dragover = false"
    />
    <v-sheet
      v-if="files.length == 0 || dragover"
      rounded
      color="rgba(0, 0, 0, 0)"
      :class="dragover? 'center d-flex highlight-dashed  bd-white' : 'center d-flex highlight-dashed'"
      height="160px"
      width="160px"
    >
      <div class="ma-auto">
        <div style="position:relative">
          <v-icon :color="dragover? 'white' : 'primary'" class="center" x-large>
            mdi-text-box-multiple-outline
          </v-icon>
        </div>
        <div class="mt-5">
          <h4 :class="dragover? 't-white' : ''">
            Drag & Drop
          </h4>
        </div>
      </div>
    </v-sheet>
    <div v-if="files.length !== 0">
      <div v-for="(file, key) in files" :key="key" style="z-index:10">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-row v-bind="attrs" class="d-flex pa-5" v-on="on">
              <v-col cols="3">
                <v-icon color="primary" large>
                  {{ getIcon(file.type) }}
                </v-icon>
                <v-icon color="secondary" large @click.stop="files.pop(key, 1)">
                  mdi-close
                </v-icon>
              </v-col>
              <v-col cols="9" class="d-flex">
                <span class="my-auto ml-2">
                  {{ file.name }}
                </span>
              </v-col>
            </v-row>
          </template>
          <span>
            {{ file.name }}
          </span>
        </v-tooltip>
        <v-divider v-if="files.length != key + 1" />
      </div>
    </div>
  </v-sheet>
</template>

<script>
export default {
   props: {
      height: {
         type: String,
         default: '240px'
      },
      width: {
         type: String,
         default: '100%'
      },
      multiple: {
         type: Boolean,
         default: true
      },
      icons: {
         type: Array,
         default: () => {
            return []
         }
      },
      acceptedMimeTypes: {
         type: Array,
         default: () => {
            return []
         }
      }
   },
   data: function () {
      return {
         dragover: false,
         files: []
      }
   },
   watch: {
      files (newVal) {
         this.$emit('input', newVal)
      }
   },
   mounted () {
      this.icons.push(...[
         { type: 'pdf', icon: 'file-pdf-box' },
         //  { type: 'jpg', icon: 'file-jpg-box' },
         //  { type: 'png', icon: 'file-png-box' },
         { type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', icon: 'microsoft-excel' },
         { type: 'xlsx', icon: 'microsoft-excel' },
         { type: 'csv', icon: 'file-delimited' },
         { type: 'vnd.ms-excel', icon: 'file-delimited' },
      ])
   },
   methods: {
      getMimeTypes () {
         let mimeTypes = ''
         for (const key in this.acceptedMimeTypes) {
            if (mimeTypes !== '') {
               mimeTypes += ','
            }
            mimeTypes += this.acceptedMimeTypes[key]
         }
         return mimeTypes
      },
      getIcon (type) {
         let icon = 'mdi-file'
         for (const key in this.icons) {
            if (type.includes(this.icons[key].type)) {
               icon = 'mdi-' + this.icons[key].icon
               break
            }
         }
         if (icon === 'mdi-file' && type.includes('image')) {
            icon = 'mdi-file-image'
         }
         return icon
      },
      prepareFile (e) {
         e.preventDefault()
         this.addFile(e.target.files)
      },
      addFile (files) {
         for (let i = 0; i < files.length; i++) {
            if (this.multiple === false) {
               this.files = [
                  files[i]
               ]
            } else {
               this.files.push(files[i])
            }
         }
      },
      drop (e) {
         this.dragover = false
         e.preventDefault()
         if (e.dataTransfer) {
            const files = e.dataTransfer.files
            this.addFile(files)
         }
      },
      upload (files) {
         this.$emit('save', files)
         this.files = []
      }
   }
}
</script>

<style scoped>

.center{
   margin: 0;
   position: absolute;
   top: 50%;
   left: 50%;
   -ms-transform: translate(-50%, -50%);
   transform: translate(-50%, -50%);
}
.highlight{
   border: 2px solid;
   border-color:  var(--v-primary-base) !important;
}
.t-white{
    color: white
}
.highlight-dashed{
    border: 4px dashed  var(--v-primary-base) !important;
}
.bd-white{
   border-color: white !important;
}
.remaining-height{
    height: calc(100% - (45px));
}
</style>
